// ContentOS Collection View Standard — shared browsing primitives reused across
// modules (Topics now; Content Items / Publications / Festivals / Knowledge
// later). Each module supplies its own properties, filters, sort options and
// card renderer while sharing the same interaction patterns & preference store.

export const DENSITIES = [
  ["compact", "Compact"],
  ["comfortable", "Comfortable"],
  ["detailed", "Detailed"],
];

// Build the default per-user display config for a collection definition.
export function defaultCollectionCfg(def) {
  return {
    density: def?.defaultDensity || "comfortable",
    hidden: [...(def?.defaultHidden || [])],
    order: (def?.properties || []).map((p) => p.key),
    sort: def?.defaultSort || "updated",
  };
}
